import {useConfig} from '@aboutyou/config';
import {DataFetcher} from '@aboutyou/data-fetcher';
import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  ContentPopper,
  ContentPopperProps,
  DrawerBody,
  ModalHeader,
  Text,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useCoinsLatestAchievementsOpenedState} from '../../../features/Coins/CoinsWallet/CoinsWalletContent/CoinsLatestAchievements/utils/useCoinsLatestAchievementsOpenedState';
import {RequestFailure} from '../../../features/Coins/shared/RequestFailure';
import {CoinsLatestAchievementsSkeleton} from './CoinsLatestAchievementsSkeleton';
import {CoinsLatestAchievementsView} from './CoinsLatestAchievementsView';
import {useGetMissionsHistory} from './utils/useGetMissionsHistory';

export const CoinsLatestAchievements: React.FC<{
  ContentPopperLayoutComponent: ContentPopperProps['LayoutComponent'];
}> = ({ContentPopperLayoutComponent}) => {
  const request = useGetMissionsHistory();
  const {isOpen, cancel} = useCoinsLatestAchievementsOpenedState();
  const {device} = useConfig();
  const {t} = useTranslation();

  return (
    <StyledContentPopper
      data-testid="coinsLatestAchievementPage"
      LayoutComponent={ContentPopperLayoutComponent}
      renderInPortal
      slideDirection="left"
      onClose={cancel}
      onGoBack={device === 'mobile' ? cancel : undefined}
      open={isOpen}
      data-has-error={!!request.error}
      headerContent={
        <Text size="px20" weight="mediumHeavy">
          {t('Achievements')}
        </Text>
      }
      bodyContent={
        <DataFetcher
          request={request}
          Loading={CoinsLatestAchievementsSkeleton}
          Error={() => <StyledRequestFailure />}
          View={CoinsLatestAchievementsView}
        />
      }
    />
  );
};

const StyledContentPopper = styled(ContentPopper)`
  z-index: ${Z_INDEXES.COINS_LATEST_ACHIEVEMENT};
  background-color: ${COLORS['Fill.White']};

  &[data-has-error='true'] {
    ${DrawerBody} {
      padding: 0;
    }
  }

  ${ModalHeader} {
    border-bottom: 1px solid ${COLORS['Outline.Grey']};
  }
`;

const StyledRequestFailure = styled(RequestFailure)`
  height: 100%;
  background-color: ${COLORS['Fill.Grey.Primary']};
  padding-top: 8rem;
`;
